import { Skeleton } from "~/components/ui/skeleton";

export function CinemaHeroSkeleton() {
  return (
    <div className="flex h-[530px] flex-col items-center justify-end px-[20px] pb-[26px] md:mx-auto md:h-[560px] md:w-full md:max-w-[1392px] md:flex-row md:items-center md:justify-start md:gap-[48px] md:px-[24px] md:pb-0">
      <Skeleton className="hidden aspect-[2/3] w-[220px] shrink-0 rounded-[12px] bg-neutral-800 md:block lg:w-[300px]" />
      <div className="flex w-full flex-col items-center gap-[14px] md:items-start md:gap-[20px]">
        <Skeleton className="h-[32px] w-3/4 bg-neutral-800 md:h-[48px] md:w-1/2" />
        <Skeleton className="h-[22px] w-1/3 rounded-full bg-neutral-800 md:h-[26px] md:w-1/4" />
        <Skeleton className="hidden h-[75px] w-full max-w-[560px] bg-neutral-800 md:block" />
        <Skeleton className="h-[44px] w-[125px] rounded-full bg-neutral-800 md:h-[48px] md:w-[129px]" />
      </div>
    </div>
  );
}
